export enum OrganizationDetailPerspective {
    RelationsPerspective = 0,
    AffiliationsPerspective = 1
}
